export function getRandomNumber(min: number, max: number): number {
  // Ensure min is less than or equal to max
  if (min > max) {
    [min, max] = [max, min];
  }

  // Generate a random number between min and max (inclusive)
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomId() {
  return crypto.randomUUID();
}
